<template>
  <v-app>
    <v-main>
      <v-container fluid>
        <v-layout align-center justify-center>
          <v-flex xs12 sm10 md8>
            <h1
              style="
                text-align: center;
                float: center;
                font-size: 2.5em;
                filter: drop-shadow(2px 4px 8px #585858);
              "
            >
              ¡Gracias por tu compra!
            </h1>
            <div style="clear: both"></div>
            <h6 style="text-align: center; float: center; font-size: 2em">
              Revisa tu correo, recibirás noticias nuestras con toda la
              información acerca de tu compra.
            </h6>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import { BASE_URL } from "./constants.js";
import { STYLE } from "./constants.js";
import genericReload from "./genericReload.js";
import * as basics from "./basics.js";

const headers = {
  "Content-Type": "application/json",
};

export default {
  name: "Gracias",
  data: () => ({}),
  async mounted() {
    const selectedWorkshop = JSON.parse(localStorage.getItem("workshop"));
    const post = JSON.parse(localStorage.getItem("post"));
    const invita1 = JSON.parse(localStorage.getItem("invita1"));
    const invita2 = JSON.parse(localStorage.getItem("invita2"));
    const invita3 = JSON.parse(localStorage.getItem("invita3"));

    // Cliente principal: creamos/reutilizamos e inscribimos en el taller.
    // "main.ok" refleja el resultado REAL de la inscripción en el taller,
    // no el de la creación del cliente (que era el bug original).
    const main = await this.registerAndEnroll(post, selectedWorkshop);

    const invitados = [];
    for (const invita of [invita1, invita2, invita3]) {
      if (invita && invita.nombre != "") {
        if (invita.email == "") {
          invita.lopd = 0;
        }
        invita.idCentro = selectedWorkshop.idCentro;
        const result = await this.registerAndEnroll(invita, selectedWorkshop);
        invitados.push({ data: invita, result });
      }
    }

    if (!main.ok || !main.id) {
      // El cliente principal no quedó correctamente creado/inscrito.
      // No tiene sentido registrar el pago ni enviar los emails de bienvenida.
      console.error(
        "No se pudo crear/inscribir al cliente principal en el taller.",
        main
      );
      return;
    }

    const tipoPago =
      selectedWorkshop.idCentro == 8 ? "TPV virtual CP" : "TPV virtual LHS";
    const fecha = selectedWorkshop.fecha.split(" ")[0];
    const precioFinal = selectedWorkshop.d
      ? selectedWorkshop.precioDescuento
      : selectedWorkshop.precio;
    const postDataPago = {
      idClient: main.id,
      fecha: basics.getDate(),
      idCentro: selectedWorkshop.idCentro,
      idProfesional: 2,
      nombreBono:
        selectedWorkshop.tipo + ": " + fecha + " - " + selectedWorkshop.nombre,
      precioBono: precioFinal,
      descuento: 0,
      pdescuento: 0,
      pago: tipoPago,
      codigo: "",
      nutricion: 0,
      psicologia: 0,
      fisioterapia: 0,
      entrenamiento: 0,
    };

    const responsePago = await fetch(`${BASE_URL}/api/withoutTokenFee`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(postDataPago),
    });

    if (!responsePago.ok) {
      // El registro del taller y del cliente ya se hizo, pero el pago falló.
      // Lo dejamos registrado en consola para poder detectarlo/reintentarlo.
      console.error(
        "El cliente quedó inscrito en el taller pero el pago NO se registró.",
        await responsePago.text().catch(() => "")
      );
    }

    let emailContent =
      post.nombre.toUpperCase().bold() +
      " " +
      post.apellidos.toUpperCase().bold() +
      " se ha unido al Taller " +
      selectedWorkshop.nombre +
      " del " +
      selectedWorkshop.fecha;
    if (post.email != "") {
      emailContent += ". Su email es " + post.email.bold();
    }
    if (post.telefono != "") {
      emailContent += ". Su teléfono es " + post.telefono.bold();
    }

    const etiquetas = [
      "Trae como invitado a ",
      "También trae como invitado a ",
      "Y también a ",
    ];
    invitados.forEach(({ data }, index) => {
      emailContent += ". " + etiquetas[index] + data.nombre + " " + data.apellidos;
      if (data.email) {
        emailContent += ". Email: " + data.email;
      }
      if (data.telefono) {
        emailContent += ". Teléfono: " + data.telefono;
      }
    });

    const emailSubject = "Nueva COMPRA DE TALLER";
    const emailData = {
      email: "comunicacion@lahabitacionsaludable.com",
      content: emailContent,
      subject: emailSubject,
    };
    await fetch(`${BASE_URL}/api/mailing`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(emailData),
    });

    const getContent = await genericReload("", "api/withoutTokenMessage");
    const messages = await getContent.json();
    const load = messages.find((message) => message.id === 26);
    const content = load.contenido;
    const subject = load.asunto;

    const destinatarios = [post.email, ...invitados.map((i) => i.data.email)];
    for (const email of destinatarios) {
      if (email && email != "") {
        const emailClientData = {
          email: email,
          content: `${STYLE}` + content,
          subject: subject,
        };
        await fetch(`${BASE_URL}/api/mailing`, {
          method: "POST",
          headers: headers,
          body: JSON.stringify(emailClientData),
        });
      }
    }
  },
  methods: {
    async checkClient(client) {
      if (client.email || client.telefono) {
        const ruta =
          "api/withoutTokenClient/?email=" +
          client.email +
          "&telefono=" +
          client.telefono;
        const responseClient = await genericReload(this.$store.state.auth, ruta);
        return await responseClient.json();
      } else {
        return [];
      }
    },

    // Crea (o reutiliza) un cliente y lo inscribe en el taller.
    // Devuelve { id, ok } donde `ok` es el resultado real de la inscripción
    // en el taller (no el de la creación del cliente).
    async registerAndEnroll(client, selectedWorkshop) {
      let existing = await this.checkClient(client);

      if (!existing || !existing.length) {
        const createResponse = await fetch(`${BASE_URL}/api/withoutTokenClient`, {
          method: "POST",
          headers: headers,
          body: JSON.stringify(client),
        });

        if (!createResponse.ok) {
          console.error("No se pudo crear el cliente.", client);
          return { id: null, ok: false };
        }

        existing = await this.checkClient(client);
      }

      if (!existing || !existing.length) {
        // Cliente sin email ni teléfono (checkClient no puede localizarlo)
        // o la búsqueda tras la creación no lo encontró.
        console.error(
          "No se pudo localizar el cliente tras crearlo (¿faltan email/teléfono?).",
          client
        );
        return { id: null, ok: false };
      }

      const clientId = existing[0].id;
      const enrollResponse = await fetch(
        `${BASE_URL}/api/withoutTokenWorkshop/${selectedWorkshop.id}/client/${clientId}`,
        {
          method: "POST",
          headers: headers,
        }
      );

      return { id: clientId, ok: enrollResponse.ok };
    },
  },
};
</script>
<style scoped>
h1 {
  color: #31e9f5;
  text-align: center;
  padding-bottom: 5%;
}
</style>